var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"d-flex"},[_c('div',{class:[
        'mb-1 subtitle-1 font-weight-bold',
        _vm.className ? _vm.className : ''
      ],domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }